import { render, staticRenderFns } from "./NewDataClientComponent.vue?vue&type=template&id=1160a3f4&scoped=true"
import script from "./NewDataClientComponent.vue?vue&type=script&lang=js"
export * from "./NewDataClientComponent.vue?vue&type=script&lang=js"
import style0 from "./NewDataClientComponent.vue?vue&type=style&index=0&id=1160a3f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1160a3f4",
  null
  
)

export default component.exports